import * as React from 'react';
import { TableProps } from 'semantic-ui-react';
import '../css/table.sass';

export default function TR(props: TableProps) {
  const { className, ...other } = props; // eslint-disable-line @typescript-eslint/no-unused-vars
  return (
    <tr className="campfire-tr" {...other}>
      {props.children}
    </tr>
  );
}
